import React, {useEffect} from "react";
import {connect} from "react-redux";
import {graphql} from "react-apollo";
import {fromJS, List} from "immutable";
import Table from "../../components/Table";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import OrderTaggingRuleItem from "./OrderTaggingRuleItem";
import {ORDER_TAGGING_RULES, ON_UPDATED_ORDER_TAGGING_RULE} from "../../queries/shipping";


const tableHeader = List([
  "Title",
  "Account",
  "Order Types",
  "SKU Pattern",
  "Tags",
  "Status",
]);

const OrderTaggingRulesList = (props) => {
  const {loading, error, shippingOrderTaggingRules} = props.data;

  useEffect(() => {
    // Subscribe once; refetch the list whenever any rule changes.
    return props.subscribeToUpdates(props.data, props.onDeleted);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) return <Loading />
  if (error) return <GraphQLErrors error={error} />

  function handleItemClick(itemData, _e, _field = "") {
    props.onSelectionChange(itemData.get("ruleId"), itemData.get("accountId"));
  }

  return (
    <div>
      <Table
        data={fromJS(shippingOrderTaggingRules || [])}
        renderer={OrderTaggingRuleItem}
        onItemClick={handleItemClick}
        tableHeader={tableHeader}
        extraClassName="OrderTaggingRulesList"
        itemKey="ruleId"
        mode="table"
        showCount={true}
        selected={props.selectedId}
        />
    </div>
  );
}

const withQuery = graphql(ORDER_TAGGING_RULES, {
  options: (props) => ({
    fetchPolicy: "network-only"
  })
});

const mapDispatchToProps = (dispatch) => ({
  subscribeToUpdates: (data, onDeleted) => {
    return data.subscribeToMore({
      document: ON_UPDATED_ORDER_TAGGING_RULE,
      updateQuery: (prev, { subscriptionData }) => {
        const update = subscriptionData.data.updatedShippingOrderTaggingRule;
        if (update.action === "deleted" && onDeleted) {
          onDeleted(update.id);
        }
        data.refetch();
        return prev;
      }
    })
  },
});

export default connect(null, mapDispatchToProps)(withQuery(OrderTaggingRulesList));
